import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface KatanaProps {
    className?: string
}

export const Katana = ({ className }: KatanaProps): ReactNode => (
    <svg viewBox='0 0 40 72' aria-hidden='true' className={cn('h-12 w-7 shrink-0 overflow-visible', className)}>
        <path d='M2 40 L38 22' stroke='#ff5ca8' strokeWidth='1.5' strokeLinecap='round' opacity='0.55' />
        <path d='M36 2 Q31 25 17 46' fill='none' stroke='#121212' strokeWidth='6.5' strokeLinecap='round' />
        <path d='M36 2 Q31 25 17 46' fill='none' stroke='#ececf1' strokeWidth='4' strokeLinecap='round' />
        <path d='M35 6 Q30.5 25 18.5 44' fill='none' stroke='#7cc8ff' strokeWidth='1.2' strokeLinecap='round' />
        <ellipse cx='15.5' cy='49' rx='6.5' ry='2.6' transform='rotate(30 15.5 49)' fill='#ffd23f' stroke='#121212' strokeWidth='1.5' />
        <path d='M13.5 52.5 L5 67' stroke='#121212' strokeWidth='7' strokeLinecap='round' />
        <path d='M13.5 52.5 L5 67' stroke='#6b2bd9' strokeWidth='5' strokeLinecap='round' />
        <path d='M13 53.5 L5.5 66' stroke='#ffd23f' strokeWidth='5' strokeDasharray='1.6 3' />
    </svg>
)

interface LogoProps {
    className?: string
}

export const Logo = ({ className }: LogoProps): ReactNode => (
    <span className={cn('group inline-flex items-center font-heading text-2xl leading-none tracking-tight', className)}>
        <span className='translate-y-1'>Draw</span>
        <Katana className='-mx-1 transition-transform duration-300 motion-safe:group-hover:-rotate-12' />
        <span className='-translate-y-1'>Sword</span>
    </span>
)
